// Central data source — all photos served locally as WebP 480/900/1200
import META from "./manifest.json";

const B = `${process.env.PUBLIC_URL || ""}/photos`;

const build = (id) => {
  const m = META[id] || { w: 1320, h: 1760 };
  return {
    srcset: `${B}/${id}_480.webp 480w, ${B}/${id}_900.webp 900w, ${B}/${id}_1200.webp 1200w`,
    src: `${B}/${id}_900.webp`,
    src1200: `${B}/${id}_1200.webp`,
    width: m.w,
    height: m.h,
  };
};

export const PHOTOS = {
  IMG_3522: build("IMG_3522"),
  IMG_3523: build("IMG_3523"),
  IMG_3524: build("IMG_3524"),
  IMG_3526: build("IMG_3526"),
  IMG_3527: build("IMG_3527"),
  IMG_3528: build("IMG_3528"),
  IMG_3529: build("IMG_3529"),
  IMG_3530: build("IMG_3530"),
  IMG_3531: build("IMG_3531"),
  IMG_3532: build("IMG_3532"),
  IMG_3533: build("IMG_3533"),
  IMG_3534: build("IMG_3534"),
  IMG_3535: build("IMG_3535"),
  IMG_3536: build("IMG_3536"),
};

export const ASSETS = {
  heroArmsCrossed: `${B}/parisfc_1_1080.webp`,
  heroArmsCrossedMobileSrcSet: `${B}/parisfc_1_640.webp 640w, ${B}/parisfc_1_1080.webp 1080w`,
  heroArmsCrossedDesktopSrcSet: `${B}/parisfc_1_1080.webp 1080w, ${B}/parisfc_1_1500.webp 1500w`,
  heroPortrait: PHOTOS.IMG_3524.src,
  parisSmile: PHOTOS.IMG_3522.src,
  signing: PHOTOS.IMG_3526.src,
  ecuadorCaptain: PHOTOS.IMG_3527.src,
  ecuadorAction: PHOTOS.IMG_3528.src,
  ecuadorClap: PHOTOS.IMG_3529.src,
  ecuadorJacket: PHOTOS.IMG_3534.src,
  ecuadorCross: PHOTOS.IMG_3535.src,
  ecuadorQualifiers: PHOTOS.IMG_3536.src,
  granadaPink: PHOTOS.IMG_3530.src,
  granadaGoal: PHOTOS.IMG_3531.src,
  granadaFan: PHOTOS.IMG_3532.src,
  granadaCelebrate: PHOTOS.IMG_3533.src,
};
